const UtilMoney = require("./UtilMoney").default;
const EntityService = require("../services/entityService").default;
const UtilDateTime = require("./UtilDateTime").default;

class UtilCapaJobPDF {
  static logoCache = null;

  static extrairIdRegistro(registro) {
    if (!registro) return "";
    if (typeof registro === "object") {
      return registro?.id || registro?._id || registro?.value || registro?.code || registro?.codigo || "";
    }
    return String(registro).trim();
  }

  static normalizarColecaoItens(...fontes) {
    const itens = [];

    fontes.forEach((fonte) => {
      if (Array.isArray(fonte)) {
        itens.push(...fonte);
        return;
      }

      if (Array.isArray(fonte?.data)) {
        itens.push(...fonte.data);
      }
    });

    return itens
      .map((item) => item?._currentData || item)
      .filter((item) => item && typeof item === "object");
  }

  static async carregarLogo() {
    if (this.logoCache) return this.logoCache;

    try {
      const response = await fetch("/img/logo-delta-ducon.png");
      if (!response.ok) {
        console.error("Erro ao buscar PNG:", response.status);
        return null;
      }
      
      const blob = await response.blob();
      console.log("PNG carregado, tamanho:", blob.size);
      
      // Converte blob para base64
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.logoCache = reader.result;
          console.log("Logo PNG convertido para base64, tamanho:", this.logoCache.length);
          resolve(this.logoCache);
        };
        reader.onerror = (error) => {
          console.error("Erro ao ler blob:", error);
          resolve(null);
        };
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Erro ao carregar logo PNG:", error);
      return null;
    }
  }

  static async gerarCapaJob(dado) {
    try {
      var pdfMake = require("pdfmake/build/pdfmake.js");
      var pdfFonts = await require("pdfmake/build/vfs_fonts.js");

      pdfMake.vfs = pdfFonts.pdfMake.vfs;

      const logo = await this.carregarLogo();
      console.log("Logo para PDF:", logo ? "OK" : "NULL");
      
      if (!logo) {
        throw new Error("Não foi possível carregar o logo");
      }
      
      const dadosEnriquecidos = await this.enriquecerDados(dado);
      const dataCapa = this.criarDefinicaoCapa(dadosEnriquecidos, logo);
      pdfMake.createPdf(dataCapa).download(`Capa_Job_${dado?.codigo || "job"}.pdf`);
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      throw error;
    }
  }

  static async enriquecerDados(dado) {
    const dados = { ...dado };

    const clienteId = dados?.cliente?.id || dados?.clienteID;
    if (
      clienteId &&
      (!dados?.cliente?.endereco || !dados?.cliente?.cnpj || !dados?.cliente?.municipio)
    ) {
      try {
        const clienteService = new EntityService("Cliente");
        const clienteResponse = await clienteService.getById(clienteId);
        const clienteCompleto = clienteResponse?.data?.data;
        if (clienteCompleto) {
          dados.cliente = { ...clienteCompleto, ...dados.cliente };
        }
      } catch (error) {
        console.error("Erro ao carregar cliente completo:", error);
      }
    }

    const solicitacaoId = this.extrairIdRegistro(
      dados?.solicitacaoDeOrcamentoId ||
      dados?.solicitacaoDeOrcamentoID ||
      dados?.salesOrderId ||
      dados?.salesOrderID ||
      dados?.salesOrder ||
      dados?.solicitacaoDeOrcamento?.id ||
      dados?.solicitacaoDeOrcamento
    );

    if (solicitacaoId) {
      try {
        const salesOrderService = new EntityService("SalesOrder");
        const salesOrderResponse = await salesOrderService.getById(solicitacaoId);
        const salesOrderCompleta = salesOrderResponse?.data?.data;

        if (salesOrderCompleta && salesOrderCompleta !== "Não encontrado") {
          dados.solicitacaoDeOrcamento = {
            ...salesOrderCompleta,
            ...dados.solicitacaoDeOrcamento,
          };
        }
      } catch (error) {
        console.error("Erro ao carregar SalesOrder:", error);
      }

      // Fallback para instalações que ainda usam esse schema/endpoint
      try {
        const solicitacaoService = new EntityService("SolicitacaoDeOrcamento");
        const solicitacaoResponse = await solicitacaoService.getById(solicitacaoId);
        const solicitacaoCompleta = solicitacaoResponse?.data?.data;

        if (solicitacaoCompleta && solicitacaoCompleta !== "Não encontrado") {
          dados.solicitacaoDeOrcamento = {
            ...solicitacaoCompleta,
            ...dados.solicitacaoDeOrcamento,
          };
        }
      } catch (error) {
        // ignora fallback indisponível
      }
    }

    const solicitacaoItemRefs = [
      ...(Array.isArray(dados?.solicitacaoDeOrcamento?.Itens) ? dados.solicitacaoDeOrcamento.Itens : []),
      ...(Array.isArray(dados?.solicitacaoDeOrcamento?._currentData?.Itens) ? dados.solicitacaoDeOrcamento._currentData.Itens : []),
      ...(Array.isArray(dados?.solicitacaoDeOrcamento?.itens) ? dados.solicitacaoDeOrcamento.itens : []),
      ...(Array.isArray(dados?.solicitacaoDeOrcamento?._currentData?.itens) ? dados.solicitacaoDeOrcamento._currentData.itens : []),
      ...(Array.isArray(dados?.solicitacaoDeOrcamento?.childrens?.SalesOrderItem) ? dados.solicitacaoDeOrcamento.childrens.SalesOrderItem : []),
      ...(Array.isArray(dados?.solicitacaoDeOrcamento?.childrens?.Itens) ? dados.solicitacaoDeOrcamento.childrens.Itens : [])
    ];
    const itensSolicitacaoEmMemoria = this.normalizarColecaoItens(solicitacaoItemRefs);
    const idsItensSolicitacao = [...new Set(
      solicitacaoItemRefs
        .map((item) => this.extrairIdRegistro(item))
        .filter(Boolean)
    )];

    if (idsItensSolicitacao.length) {
      try {
        const salesOrderItemService = new EntityService("SalesOrderItem");
        const itensBuscados = await Promise.all(
          idsItensSolicitacao.map(async (id) => {
            try {
              const itemResponse = await salesOrderItemService.getById(id);
              return itemResponse?.data?.data?._currentData || itemResponse?.data?.data || null;
            } catch (error) {
              return null;
            }
          })
        );

        const mapaItens = new Map();
        [...itensSolicitacaoEmMemoria, ...itensBuscados]
          .filter((item) => item && typeof item === "object")
          .forEach((item) => {
            const id = this.extrairIdRegistro(item);
            if (!id) return;
            mapaItens.set(id, item);
          });

        dados.solicitacaoItensDetalhes = Array.from(mapaItens.values());
      } catch (error) {
        console.error("Erro ao carregar itens da solicitação:", error);
        dados.solicitacaoItensDetalhes = itensSolicitacaoEmMemoria;
      }
    } else {
      dados.solicitacaoItensDetalhes = itensSolicitacaoEmMemoria;
    }

    const contatoComercialId =
      dados?.solicitacaoDeOrcamentoContatoComercialID ||
      dados?.solicitacaoDeOrcamento?._currentData?.contatoComercial ||
      dados?.solicitacaoDeOrcamento?.contatoComercial;
    if (contatoComercialId) {
      try {
        const contatoService = new EntityService("ClienteContatos");
        const contatoResponse = await contatoService.getById(contatoComercialId);
        const contatoCompleto = contatoResponse?.data?.data;
        if (contatoCompleto) {
          dados.contatoComercialDetalhe = contatoCompleto;
        }
      } catch (error) {
        console.error("Erro ao carregar contato comercial:", error);
      }
    }

    const contatoTecnicoId =
      dados?.solicitacaoDeOrcamentoContatoTecnicoID ||
      dados?.solicitacaoDeOrcamento?._currentData?.contatoTecnico ||
      dados?.solicitacaoDeOrcamento?.contatoTecnico;
    if (contatoTecnicoId) {
      try {
        const contatoService = new EntityService("ClienteContatos");
        const contatoResponse = await contatoService.getById(contatoTecnicoId);
        const contatoCompleto = contatoResponse?.data?.data;
        if (contatoCompleto) {
          dados.contatoTecnicoDetalhe = contatoCompleto;
        }
      } catch (error) {
        console.error("Erro ao carregar contato tecnico:", error);
      }
    }

    const revisoesComerciais =
      dados?.solicitacaoDeOrcamento?._currentData?.revisoesComerciais ||
      dados?.solicitacaoDeOrcamento?.revisoesComerciais ||
      [];
    const revisaoComercialRef = Array.isArray(revisoesComerciais)
      ? revisoesComerciais[0]
      : revisoesComerciais;
    const revisaoComercialId =
      typeof revisaoComercialRef === "object"
        ? revisaoComercialRef?.id || revisaoComercialRef?._id || revisaoComercialRef?._currentData?.id
        : revisaoComercialRef;

    if (revisaoComercialId) {
      try {
        const revisaoService = new EntityService("SalesOrderRevisao");
        const revisaoResponse = await revisaoService.getById(revisaoComercialId);
        const revisaoCompleta = revisaoResponse?.data?.data;

        if (revisaoCompleta && revisaoCompleta !== "Não encontrado") {
          dados.revisaoComercialDetalhe = revisaoCompleta;
        }
      } catch (error) {
        console.error("Erro ao carregar revisao comercial:", error);
      }
    } else if (revisaoComercialRef && typeof revisaoComercialRef === "object") {
      dados.revisaoComercialDetalhe = revisaoComercialRef?._currentData || revisaoComercialRef;
    }

    return dados;
  }

  static criarDefinicaoCapa(dado, logo) {
    console.log("criarDefinicaoCapa - logo recebido:", logo ? logo.substring(0, 50) + "..." : "NULL");
    
    const dataAtual = new Date();
    const dia = String(dataAtual.getDate()).padStart(2, "0");
    const mes = String(dataAtual.getMonth() + 1).padStart(2, "0");
    const ano = dataAtual.getFullYear();
    const dataEmissao = `${dia}/${mes}/${ano}`;

    const formatNumberPt = (value) => {
      if (value === null || value === undefined || value === "") return "";
      if (typeof value === "number") {
        return value.toLocaleString("pt-BR");
      }
      return value;
    };
    const toNumber = (value) => {
      if (value === null || value === undefined || value === "") return 0;
      if (typeof value === "number") return value;
      return Number(String(value).replace(/\./g, "").replace(",", ".")) || 0;
    };
    const obterValorNumerico = (...values) => {
      for (const value of values) {
        if (!hasValue(value)) continue;
        const numero = toNumber(value);
        if (Number.isFinite(numero)) return numero;
      }
      return 0;
    };
    const obterValorNumericoPreferindoPositivo = (...values) => {
      let primeiroNumero = null;

      for (const value of values) {
        if (!hasValue(value)) continue;
        const numero = toNumber(value);
        if (!Number.isFinite(numero)) continue;
        if (primeiroNumero === null) primeiroNumero = numero;
        if (numero > 0) return numero;
      }

      return primeiroNumero ?? 0;
    };
    const hasValue = (value) => value !== null && value !== undefined && value !== "";
    const primeiroValor = (...values) => values.find((value) => hasValue(value));
    const formatarPercentualBloco = (value, fallback = "-") => (hasValue(value) ? `${value}%` : fallback);
    const ALIQUOTA_PADRAO_PIS = 1.65;
    const ALIQUOTA_PADRAO_COFINS = 7.6;
    const obterPercentualComPadrao = (value, padrao) => {
      const numero = toNumber(value);
      if (Number.isFinite(numero) && numero > 0) return numero;
      return padrao;
    };

    const clienteCodigo = dado?.cliente?.codigo || dado?.clienteCodigo || "";
    const clienteNome = dado?.cliente?.nomeFantasia || dado?.cliente?.nome || dado?.clienteNome || "";
    
    // Monta endereço completo do cliente
    const clienteEndereco = dado?.cliente?.faturamentoEndereco 
      ? `${dado.cliente.faturamentoEndereco}${dado.cliente.faturamentoNumero ? ', ' + dado.cliente.faturamentoNumero : ''}${dado.cliente.faturamentoBairro && dado.cliente.faturamentoBairro !== '---' ? ' - ' + dado.cliente.faturamentoBairro : ''}`
      : (dado?.cliente?.endereco || "");
    
    const clienteMunicipio = dado?.cliente?.faturamentoCidadeNome 
      ? `${dado.cliente.faturamentoCidadeNome}${dado.cliente.faturamentoEstadoNome ? ' - ' + dado.cliente.faturamentoEstadoNome : ''}${dado.cliente.faturamentoCEP ? ' - CEP: ' + dado.cliente.faturamentoCEP : ''}`
      : (dado?.cliente?.municipio || "");
    
    const clienteCNPJ = dado?.cliente?.cnpj || "";
    const clienteInscricaoEstadual = dado?.cliente?.inscricaoEstadual || "";
    
    // Estrutura da solicitacao pode estar em diferentes lugares
    const solicitacao = dado?.solicitacaoDeOrcamento?._currentData || dado?.solicitacaoDeOrcamento || {};
    const childrens = dado?.solicitacaoDeOrcamento?.childrens || {};

    // Dados do vendedor
    const vendedorNome =
      solicitacao?.vendedorNome ||
      dado?.solicitacaoDeOrcamentoVendedorNome ||
      dado?.cliente?.vendedorNome ||
      dado?.vendedorNome ||
      "";

    // Dados dos contatos
    const contatoComercialNome =
      solicitacao?.contatoComercialNome ||
      dado?.solicitacaoDeOrcamentoContatoComercialNome ||
      dado?.contatoComercialDetalhe?.nome ||
      "";
    const contatoComercialEmail =
      solicitacao?.contatoComercialEmail ||
      dado?.contatoComercialDetalhe?.email ||
      "";
    const contatoComercialTelefone =
      solicitacao?.contatoComercialTelefone ||
      dado?.contatoComercialDetalhe?.telefone ||
      "";
    const contatoComercialCelular =
      solicitacao?.contatoComercialCelular ||
      dado?.contatoComercialDetalhe?.celular ||
      "";

    const contatoTecnicoNome =
      solicitacao?.contatoTecnicoNome ||
      dado?.solicitacaoDeOrcamentoContatoTecnicoNome ||
      dado?.contatoTecnicoDetalhe?.nome ||
      "";
    const contatoTecnicoEmail =
      solicitacao?.contatoTecnicoEmail ||
      dado?.contatoTecnicoDetalhe?.email ||
      "";
    const contatoTecnicoTelefone =
      solicitacao?.contatoTecnicoTelefone ||
      dado?.contatoTecnicoDetalhe?.telefone ||
      "";
    const contatoTecnicoCelular =
      solicitacao?.contatoTecnicoCelular ||
      dado?.contatoTecnicoDetalhe?.celular ||
      "";

    // Dados do orcamentista
    const orcamentistaNome =
      solicitacao?.orcamentistaNome ||
      dado?.solicitacaoDeOrcamentoOrcamentistaNome ||
      dado?.solicitacaoDeOrcamento?.orcamentistaNome ||
      dado?.solicitacaoDeOrcamento?._currentData?.orcamentistaNome ||
      "";
    
    // Dados da revisão comercial
    const revisaoComercialRaw =
      dado?.revisaoComercialDetalhe ??
      childrens?.SalesOrderRevisao ??
      {};
    const revisaoComercialBase = Array.isArray(revisaoComercialRaw)
      ? revisaoComercialRaw[0]
      : revisaoComercialRaw;
    const revisaoComercial = revisaoComercialBase?._currentData || revisaoComercialBase || {};
    const itensSolicitacao = this.normalizarColecaoItens(
      dado?.solicitacaoItensDetalhes,
      solicitacao?.Itens,
      solicitacao?._currentData?.Itens,
      solicitacao?.itens,
      solicitacao?._currentData?.itens,
      childrens?.SalesOrderItem,
      childrens?.Itens
    );
    const itensCalculo = itensSolicitacao.length > 0 ? itensSolicitacao : (Array.isArray(dado?.itens) ? dado.itens : []);
    const itemComPIS = itensCalculo.find((item) => item?.porcentagemPIS !== undefined);
    const itemComCOFINS = itensCalculo.find((item) => item?.porcentagemCOFINS !== undefined);
    const itemComISS = itensCalculo.find((item) => item?.porcentagemISS !== undefined || item?.porcentagemIIS !== undefined);
    const itemComICMS = itensCalculo.find((item) => item?.porcentagemICMSVenda !== undefined || item?.porcentagemICMS !== undefined);
    const itemComIPI = itensCalculo.find((item) => item?.pocentagemIPIVenda !== undefined || item?.porcentagemIPI !== undefined);
    const porcentagemPISInformada =
      revisaoComercial?.porcentagemPIS
      ?? solicitacao?.porcentagemPIS
      ?? solicitacao?._currentData?.porcentagemPIS
      ?? itemComPIS?.porcentagemPIS
      ?? "";
    const porcentagemCOFINSInformada =
      revisaoComercial?.porcentagemCOFINS
      ?? solicitacao?.porcentagemCOFINS
      ?? solicitacao?._currentData?.porcentagemCOFINS
      ?? itemComCOFINS?.porcentagemCOFINS
      ?? "";
    const porcentagemPISNumero = obterPercentualComPadrao(porcentagemPISInformada, ALIQUOTA_PADRAO_PIS);
    const porcentagemCOFINSNumero = obterPercentualComPadrao(porcentagemCOFINSInformada, ALIQUOTA_PADRAO_COFINS);
    const porcentagemPIS = formatNumberPt(porcentagemPISNumero);
    const porcentagemCOFINS = formatNumberPt(porcentagemCOFINSNumero);
    const porcentagemISS = formatNumberPt(revisaoComercial?.porcentagemISS ?? itemComISS?.porcentagemISS ?? itemComISS?.porcentagemIIS ?? "");
    const porcentagemICMS = formatNumberPt(revisaoComercial?.porcentagemICMSVenda ?? itemComICMS?.porcentagemICMSVenda ?? itemComICMS?.porcentagemICMS ?? "");
    const porcentagemIPI = formatNumberPt(revisaoComercial?.pocentagemIPIVenda ?? revisaoComercial?.porcentagemIPIVenda ?? itemComIPI?.pocentagemIPIVenda ?? itemComIPI?.porcentagemIPI ?? "");
    const ki = formatNumberPt(revisaoComercial?.ki ?? solicitacao?.ki ?? "");
    const kv = formatNumberPt(revisaoComercial?.kv ?? solicitacao?.kv ?? "");
    
    // Tipo de equipamento
    const tipoEquipamento =
      solicitacao?._mirror_tipo ||
      childrens?.TipoDeEquipamento?.description ||
      dado?.solicitacaoDeOrcamentoTipoDeEquipamentoDescricao ||
      "";

    const condicaoPagamento =
      dado?.condicaoDePagamento ||
      dado?.condicaoPagamento ||
      solicitacao?.condicaoDePagamento ||
      "";

    const responsavelNome =
      dado?.responsavelNome ||
      dado?.responsavel ||
      dado?.colaborador?.[0]?.name ||
      dado?.colaborador?.nome ||
      dado?.gestorNome ||
      dado?.coordenadorNome ||
      dado?.comercialNome ||
      "";

    const transporteDescricao =
      dado?.transporteDescricaoCompleta ||
      dado?.transporte?.descricaoCompleta ||
      dado?.transporte?.descricao ||
      dado?.transporteDescricao ||
      "Por conta do cliente.";

    const cartaFiancaNotaPromissoria =
      dado?.cartaFiancaNotaPromissoria ||
      dado?.cartaFianca ||
      dado?.notaPromissoria ||
      "NÃO";

    const reajusteDescricao = dado?.reajuste || dado?.reajusteDescricao || "NÃO";

    const inspecaoDescricao =
      dado?.inspecao ||
      dado?.inspecaoDescricao ||
      (dado?.naoTemInspecao ? "NÃO" : "SIM");

    const multaDescricao =
      dado?.multa ||
      dado?.multaDescricao ||
      dado?.multasContratuaisDescricao ||
      "";

    const valorAcrescimos = dado?.acrescimos || 0;
    const valorDescontos = dado?.descontos || 0;

    const obterQuantidadeItem = (item = {}) => {
      const quantidade = toNumber(item?.quantidade ?? item?.qty ?? 1);
      return quantidade > 0 ? quantidade : 1;
    };
    const obterTotalVendaItem = (item = {}) => {
      const totalInformado = toNumber(primeiroValor(item?.vlrTotal, item?.valorTotal, item?.precoTotal));
      if (totalInformado > 0) return totalInformado;
      return obterQuantidadeItem(item) * toNumber(item?.precoVenda_sIPI_cICMS);
    };
    const obterTotalCustoItem = (item = {}) => {
      const totalInformado = toNumber(item?.valorDisponivelTotal);
      if (totalInformado > 0) return totalInformado;
      return obterQuantidadeItem(item) * toNumber(item?.valorDisponivel);
    };
    const obterValorTotalImpostoItem = ({
      item = {},
      campoTotal = "",
      campoUnitario = "",
      percentual = 0,
      baseCalculo = 0,
      quantidade = 1,
      multiplicarUnitarioPorQuantidade = false
    }) => {
      const totalInformado = toNumber(item?.[campoTotal]);
      if (totalInformado > 0) return totalInformado;

      const unitarioInformado = toNumber(item?.[campoUnitario]);
      if (unitarioInformado > 0) {
        if (multiplicarUnitarioPorQuantidade) {
          return Number((unitarioInformado * (toNumber(quantidade) || 1)).toFixed(2));
        }
        return unitarioInformado;
      }

      if (baseCalculo > 0 && percentual > 0) {
        return Number(((baseCalculo * percentual) / 100).toFixed(2));
      }

      return 0;
    };

    const calcularImpostosItem = (item = {}) => {
      const quantidade = obterQuantidadeItem(item);
      const valorOrcamentoItem = obterTotalVendaItem(item);
      const valorCustoItem = obterTotalCustoItem(item);
      const basePisCofins = valorCustoItem > 0 ? valorCustoItem : valorOrcamentoItem;
      const baseIpiComIcmsItem = toNumber(item?.precoVenda_sIPI_cICMS) > 0
        ? quantidade * toNumber(item?.precoVenda_sIPI_cICMS)
        : valorOrcamentoItem;
      const percentualPIS = obterPercentualComPadrao(item?.porcentagemPIS, porcentagemPISNumero);
      const percentualCOFINS = obterPercentualComPadrao(item?.porcentagemCOFINS, porcentagemCOFINSNumero);
      const percentualISS = toNumber(item?.porcentagemISS ?? item?.porcentagemIIS);
      const percentualICMS = toNumber(item?.porcentagemICMSVenda ?? item?.porcentagemICMS);
      const percentualIPI = toNumber(item?.pocentagemIPIVenda ?? item?.porcentagemIPI);

      const baseSemIcms = toNumber(item?.precoVenda_sIPI_sICMS) > 0
        ? quantidade * toNumber(item?.precoVenda_sIPI_sICMS)
        : Number((valorOrcamentoItem - (valorOrcamentoItem * percentualICMS) / 100).toFixed(2));

      const valorPIS = obterValorTotalImpostoItem({
        item,
        campoTotal: "valorPISTotal",
        campoUnitario: "valorPIS",
        percentual: percentualPIS,
        baseCalculo: basePisCofins
      });

      const valorCOFINS = obterValorTotalImpostoItem({
        item,
        campoTotal: "valorCOFINSTotal",
        campoUnitario: "valorCOFINS",
        percentual: percentualCOFINS,
        baseCalculo: basePisCofins
      });

      const valorISS = obterValorTotalImpostoItem({
        item,
        campoTotal: "valorISSTotal",
        campoUnitario: "valorISS",
        percentual: percentualISS,
        baseCalculo: baseSemIcms
      });

      const valorIPIInformado = obterValorTotalImpostoItem({
        item,
        campoTotal: "valorIPITotal",
        campoUnitario: "valorIPI",
        percentual: percentualIPI,
        baseCalculo: baseIpiComIcmsItem
      });
      const valorIPI = percentualIPI > 0
        ? Number(((baseIpiComIcmsItem * percentualIPI) / 100).toFixed(2))
        : valorIPIInformado;

      // ICMS do item deve refletir o total do item (Valor Orç.) para evitar distorções.
      const baseICMS = Number(valorOrcamentoItem.toFixed(2));

      const valorICMS = obterValorTotalImpostoItem({
        item,
        campoTotal: "valorICMSTotal",
        campoUnitario: "",
        percentual: percentualICMS,
        baseCalculo: baseICMS
      });

      return {
        item,
        valorOrcamento: valorOrcamentoItem,
        valorCusto: valorCustoItem,
        valorPIS,
        valorCOFINS,
        valorISS,
        valorIPI,
        valorICMS,
      };
    };

    const calculosItens = itensCalculo.map((item) => calcularImpostosItem(item));

    const totaisItens = calculosItens.reduce((soma, calculo) => {
      soma.valorOrcamento += calculo.valorOrcamento;
      soma.valorISS += calculo.valorISS;
      soma.valorPIS += calculo.valorPIS;
      soma.valorCOFINS += calculo.valorCOFINS;
      soma.valorIPI += calculo.valorIPI;
      soma.valorICMS += calculo.valorICMS;
      return soma;
    }, { valorOrcamento: 0, valorISS: 0, valorPIS: 0, valorCOFINS: 0, valorIPI: 0, valorICMS: 0 });

    // Calcula totais dos itens
    const somaValoresItens = totaisItens.valorOrcamento;
    const somaISSItens = totaisItens.valorISS;
    const valorOrcamento = obterValorNumericoPreferindoPositivo(
      revisaoComercial?.valor_sIPI_cICMS,
      revisaoComercial?.valorSemIPIComICMS,
      solicitacao?._mirror_valor_sIPI_cICMS,
      solicitacao?.valor_sIPI_cICMS,
      solicitacao?.valorSemIPIComICMS,
      dado?.solicitacaoDeOrcamento?._mirror_valor_sIPI_cICMS,
      dado?.solicitacaoDeOrcamento?._currentData?._mirror_valor_sIPI_cICMS,
      dado?.solicitacaoDeOrcamentoValor,
      somaValoresItens
    );

    const temItensParaTotalizar = calculosItens.length > 0;
    const somaItensISS = totaisItens.valorISS;
    const somaItensIPI = totaisItens.valorIPI;
    const somaItensICMS = totaisItens.valorICMS;
    const usarOrcamentoGeralNosTotais = calculosItens.length > 1;
    const baseIpiComIcmsResumo = temItensParaTotalizar
      ? (usarOrcamentoGeralNosTotais
        ? (valorOrcamento > 0 ? valorOrcamento : somaValoresItens)
        : somaValoresItens)
      : (valorOrcamento > 0 ? valorOrcamento : somaValoresItens);
    const somaISS = temItensParaTotalizar
          ? (usarOrcamentoGeralNosTotais
            ? obterValorNumericoPreferindoPositivo(
                revisaoComercial?.valorISS,
                solicitacao?.valorISS,
                solicitacao?._currentData?.valorISS,
                dado?.solicitacaoDeOrcamentoValorISS,
                valorOrcamento * toNumber(porcentagemISS) / 100
              )
            : somaItensISS)
          : obterValorNumericoPreferindoPositivo(
              revisaoComercial?.valorISS,
              solicitacao?.valorISS,
              solicitacao?._currentData?.valorISS,
              dado?.solicitacaoDeOrcamentoValorISS,
              valorOrcamento * toNumber(porcentagemISS) / 100
            );
    const somaIPI = temItensParaTotalizar
      ? somaItensIPI
      : obterValorNumericoPreferindoPositivo(
          revisaoComercial?.valorIPI,
          solicitacao?.valorIPI,
          solicitacao?._currentData?.valorIPI,
          dado?.solicitacaoDeOrcamentoValorIPI,
          baseIpiComIcmsResumo * toNumber(porcentagemIPI) / 100
        );
    const somaICMS = temItensParaTotalizar
          ? (usarOrcamentoGeralNosTotais
            ? obterValorNumericoPreferindoPositivo(
                revisaoComercial?.valorICMS,
                solicitacao?.valorICMS,
                solicitacao?._currentData?.valorICMS,
                dado?.solicitacaoDeOrcamentoValorICMS,
                valorOrcamento * toNumber(porcentagemICMS) / 100
              )
            : somaItensICMS)
          : obterValorNumericoPreferindoPositivo(
              revisaoComercial?.valorICMS,
              solicitacao?.valorICMS,
              solicitacao?._currentData?.valorICMS,
              dado?.solicitacaoDeOrcamentoValorICMS,
              valorOrcamento * toNumber(porcentagemICMS) / 100
            );
    const somaValores = baseIpiComIcmsResumo;
    const aliquotaPISResumo = toNumber(porcentagemPIS) / 100;
    const aliquotaCOFINSResumo = toNumber(porcentagemCOFINS) / 100;
    const precoComIpiComIcms = Number((somaValores + somaIPI).toFixed(2));
    const valorLiquidoCalculado = Number((precoComIpiComIcms - somaICMS - somaISS - somaIPI).toFixed(2));
    const basePisCofinsResumo = valorLiquidoCalculado > 0 ? valorLiquidoCalculado : 0;
    const somaPIS = Number((basePisCofinsResumo * aliquotaPISResumo).toFixed(2));
    const somaCOFINS = Number((basePisCofinsResumo * aliquotaCOFINSResumo).toFixed(2));
    const temItensParaResumo = calculosItens.length > 0;

    const blocosPercentuais = temItensParaResumo
      ? calculosItens.map((calculo, index) => {
          const item = calculo.item || {};
          const descricaoItem = String(item?.descricao || item?.description || `Item ${index + 1}`).trim();
          const porcentagemPISItem = formatNumberPt(obterPercentualComPadrao(item?.porcentagemPIS, porcentagemPISNumero));
          const porcentagemCOFINSItem = formatNumberPt(obterPercentualComPadrao(item?.porcentagemCOFINS, porcentagemCOFINSNumero));

          return {
            table: {
              widths: ["58%", "10.5%", "10.5%", "10.5%", "10.5%"],
              body: [
                [
                  {
                    text: [
                      { text: `Item: `, bold: true, fontSize: 8 },
                      { text: descricaoItem, fontSize: 8 }
                    ],
                    margin: [3, 5, 3, 5],
                    border: [true, true, true, true]
                  },
                  {
                    text: [
                      { text: "PIS\n", bold: true, fontSize: 6 },
                      { text: formatarPercentualBloco(porcentagemPISItem), fontSize: 8, alignment: "center" }
                    ],
                    alignment: "center",
                    margin: [2, 4, 2, 4],
                    border: [true, true, true, true]
                  },
                  {
                    text: [
                      { text: "COFINS\n", bold: true, fontSize: 6 },
                      { text: formatarPercentualBloco(porcentagemCOFINSItem), fontSize: 8, alignment: "center" }
                    ],
                    alignment: "center",
                    margin: [2, 4, 2, 4],
                    border: [true, true, true, true]
                  },
                  {
                    text: [
                      { text: "Ki\n", bold: true, fontSize: 6 },
                      { text: hasValue(item?.ki) ? String(item.ki) : (hasValue(ki) ? String(ki) : "-"), fontSize: 8, alignment: "center" }
                    ],
                    alignment: "center",
                    margin: [2, 4, 2, 4],
                    border: [true, true, true, true]
                  },
                  {
                    text: [
                      { text: "Kv\n", bold: true, fontSize: 6 },
                      { text: hasValue(item?.kv) ? String(item.kv) : (hasValue(kv) ? String(kv) : "-"), fontSize: 8, alignment: "center" }
                    ],
                    alignment: "center",
                    margin: [2, 4, 2, 4],
                    border: [true, true, true, true]
                  }
                ]
              ]
            },
            layout: {
              hLineWidth: () => 0.5,
              vLineWidth: () => 0.5,
              hLineColor: "#cccccc",
              vLineColor: "#cccccc"
            },
            margin: [0, 0, 0, index === calculosItens.length - 1 ? 15 : 8]
          };
        })
      : [{
          table: {
            widths: ["50%", "50%"],
            body: [
              [
                {
                  text: [
                    { text: "Ki\n", bold: true, fontSize: 7 },
                    { text: hasValue(ki) ? String(ki) : "-", fontSize: 10, alignment: "center" }
                  ],
                  alignment: "center",
                  margin: [3, 5, 3, 5],
                  border: [true, true, true, true]
                },
                {
                  text: [
                    { text: "Kv\n", bold: true, fontSize: 7 },
                    { text: hasValue(kv) ? String(kv) : "-", fontSize: 10, alignment: "center" }
                  ],
                  alignment: "center",
                  margin: [3, 5, 3, 5],
                  border: [true, true, true, true]
                }
              ]
            ]
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
            hLineColor: "#cccccc",
            vLineColor: "#cccccc"
          },
          margin: [0, 0, 0, 15]
        }];

    // Mapeamento de datas formatadas
    const dataEnvioAprovacaoContratualFormatada = dado?.dataEnvioAprovacaoContratualFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataEnvioAprovacaoContratual}) || "";
    const dataEnvioAprovacaoEfetivaFormatada = dado?.dataEnvioAprovacaoEfetivaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataEnvioAprovacaoEfetiva}) || "";
    const dataAprovacaoPrevistaFormatada = dado?.dataAprovacaoPrevistaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataAprovacaoPrevista}) || "";
    const dataAprovacaoEfetivaFormatada = dado?.dataAprovacaoEfetivaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataAprovacaoEfetiva}) || "";
    const dataInspecaoPrevistaFormatada = dado?.dataInspecaoPrevistaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataInspecaoPrevista}) || "";
    const dataInspecaoEfetivaFormatada = dado?.dataInspecaoEfetivaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataInspecaoEfetiva}) || "";
    const dataEntregaFiscalPrevistaFormatada = dado?.dataEntregaFiscalPrevistaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataEntregaFiscalPrevista}) || "";
    const dataEntregaFiscalEfetivaFormatada = dado?.dataEntregaFiscalEfetivaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataEntregaFiscalEfetiva}) || "";
    const dataMontagemContratualFormatada = dado?.dataMontagemContratualFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataMontagemContratual}) || "";
    const dataMontagemEfetivaFormatada = dado?.dataMontagemEfetivaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataMontagemEfetiva}) || "";
    const dataStartupPrevistaFormatada = dado?.dataStartupPrevistaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataStartupPrevista}) || "";
    const dataStartupEfetivaFormatada = dado?.dataStartupEfetivaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataStartupEfetiva}) || "";
    const dataFinalContratualFormatada = dado?.dataFinalContratualFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataFinalContratual}) || "";
    const dataFinalEfetivaFormatada = dado?.dataFinalEfetivaFormatada || UtilDateTime.toFormatBrazil({dateTime: dado?.dataFinalEfetiva}) || "";

    const docDef = {
      pageSize: "A4",
      pageMargins: [30, 30, 30, 30],
      images: {
        logoImage: logo
      },
      content: [
        // LOGO E JOB - CABEÇALHO SUPERIOR
        {
          columns: [
            {
              width: "50%",
              image: 'logoImage',
              fit: [200, 80],
              alignment: "left",
            },
            {
              width: "50%",
              text: [
                { text: "JOB: ", bold: true, fontSize: 14 },
                { text: dado?.codigo || "", bold: true, fontSize: 16 },
              ],
              alignment: "right",
              margin: [0, 10, 0, 0],
            },
          ],
          margin: [0, 0, 0, 20],
        },

        // LINHA SEPARADORA
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 535,
              y2: 0,
              lineWidth: 1,
              lineColor: "#000000",
            },
          ],
          margin: [0, 0, 0, 15],
        },

        // INÍCIO DO CABEÇALHO - DADOS DO CLIENTE
        {
          table: {
            widths: ["*"],
            body: [
              [
                {
                  columns: [
                    {
                      width: "50%",
                      text: [
                        { text: "Cliente", bold: true, fontSize: 9 },
                        { text: "...........: ", fontSize: 9 },
                        {
                          text: `${clienteCodigo} - ${clienteNome}`,
                          bold: true,
                          fontSize: 10,
                        },
                      ],
                    },
                    {
                      width: "50%",
                      text: [
                        { text: "JOB", bold: true, fontSize: 9 },
                        { text: ": ", fontSize: 9 },
                        {
                          text: dado?.codigo || "",
                          bold: true,
                          fontSize: 12,
                        },
                      ],
                    },
                  ],
                  margin: [0, 5, 0, 5],
                },
              ],
              [
                {
                  columns: [
                    {
                      width: "50%",
                      text: [
                        { text: "Endereço", bold: true, fontSize: 9 },
                        { text: ".........: ", fontSize: 9 },
                        { text: clienteEndereco, fontSize: 10 },
                      ],
                    },
                    {
                      width: "50%",
                      text: [
                        { text: "C.G.C.", bold: true, fontSize: 9 },
                        { text: "...............: ", fontSize: 9 },
                        { text: clienteCNPJ, fontSize: 10 },
                      ],
                    },
                  ],
                  margin: [0, 3, 0, 3],
                },
              ],
              [
                {
                  columns: [
                    {
                      width: "50%",
                      text: [
                        { text: "Município", bold: true, fontSize: 9 },
                        { text: ".......: ", fontSize: 9 },
                        { text: clienteMunicipio, fontSize: 10 },
                      ],
                    },
                    {
                      width: "50%",
                      text: [
                        { text: "Inscr.Estadual", bold: true, fontSize: 9 },
                        { text: "........: ", fontSize: 9 },
                        { text: clienteInscricaoEstadual, fontSize: 10 },
                      ],
                    },
                  ],
                  margin: [0, 3, 0, 3],
                },
              ],
            ],
          },
          layout: "noBorders",
          margin: [0, 0, 0, 10],
        },

        // LINHA SEPARADORA
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 535,
              y2: 0,
              lineWidth: 0.5,
              lineColor: "#000000",
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // SEÇÃO CONTATOS E DATAS
        {
          table: {
            widths: ["25%", "25%", "25%", "25%"],
            body: [
              [
                {
                  text: [
                    { text: "Contato Coml.:\n", bold: true, fontSize: 8 },
                    { text: contatoComercialNome, fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "e_mail Coml...:\n", bold: true, fontSize: 8 },
                    {
                      text: contatoComercialEmail,
                      fontSize: 7,
                    },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Contato Tec...:\n", bold: true, fontSize: 8 },
                    { text: contatoTecnicoNome, fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "e_mail Tec......:\n", bold: true, fontSize: 8 },
                    {
                      text: contatoTecnicoEmail,
                      fontSize: 7,
                    },
                  ],
                  margin: [3, 3, 3, 3],
                },
              ],
              [
                {
                  text: [
                    { text: "DataAbertura..: ", bold: true, fontSize: 8 },
                    {
                      text: dado?.dataAberturaFormatada || "",
                      fontSize: 8,
                    },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Data Encerramento: ", bold: true, fontSize: 8 },
                    {
                      text: dado?.dataEncerramentoFormatada || "",
                      fontSize: 8,
                    },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Proposta.........: ", bold: true, fontSize: 8 },
                    { text: solicitacao?.codigo || "", fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Pedido Cliente.......: ", bold: true, fontSize: 8 },
                    { text: dado?.clientePedidoDeCompra || "", fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
              ],
              [
                {
                  text: [
                    { text: "Vendedor.......: ", bold: true, fontSize: 8 },
                    { text: vendedorNome, fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Orcamentista.: ", bold: true, fontSize: 8 },
                    { text: orcamentistaNome, fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Fone/Cel Coml.: ", bold: true, fontSize: 8 },
                    {
                      text: contatoComercialTelefone + (contatoComercialCelular ? ' / ' + contatoComercialCelular : ''),
                      fontSize: 8,
                    },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  text: [
                    { text: "Fone/Cel Tec.: ", bold: true, fontSize: 8 },
                    {
                      text: contatoTecnicoTelefone + (contatoTecnicoCelular ? ' / ' + contatoTecnicoCelular : ''),
                      fontSize: 8,
                    },
                  ],
                  margin: [3, 3, 3, 3],
                },
              ],
              [
                {
                  text: [
                    { text: "Responsável..: ", bold: true, fontSize: 8 },
                    { text: responsavelNome, fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
                { text: "", margin: [3, 3, 3, 3] },
                { text: "", margin: [3, 3, 3, 3] },
                { text: "", margin: [3, 3, 3, 3] },
              ],
            ],
          },
          layout: "noBorders",
          margin: [0, 0, 0, 10],
        },

        // LINHA SEPARADORA
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 535,
              y2: 0,
              lineWidth: 0.5,
              lineColor: "#000000",
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // INFORMAÇÕES DE PERCENTUAIS / ÍNDICES
        ...blocosPercentuais,

        // SEÇÃO DE VALORES
        {
          table: {
            widths: ["40%", "60%"],
            body: [
              [
                { text: "Valor ISS", bold: true, fontSize: 9 },
                {
                  text: UtilMoney.toR$BRL(somaISS),
                  alignment: "right",
                  fontSize: 9,
                },
              ],
              [
                { text: "Valor PIS", bold: true, fontSize: 9 },
                {
                  text: UtilMoney.toR$BRL(somaPIS),
                  alignment: "right",
                  fontSize: 9,
                },
              ],
              [
                { text: "Valor COFINS", bold: true, fontSize: 9 },
                {
                  text: UtilMoney.toR$BRL(somaCOFINS),
                  alignment: "right",
                  fontSize: 9,
                },
              ],
              [
                { text: "Valor IPI", bold: true, fontSize: 9 },
                {
                  text: UtilMoney.toR$BRL(somaIPI),
                  alignment: "right",
                  fontSize: 9,
                },
              ],
              [
                { text: "Valor ICMS", bold: true, fontSize: 9 },
                {
                  text: UtilMoney.toR$BRL(somaICMS),
                  alignment: "right",
                  fontSize: 9,
                },
              ],
              [
                { text: "Preço s/ IPI c/ ICMS", bold: true, fontSize: 9 },
                {
                  text: UtilMoney.toR$BRL(somaValores),
                  alignment: "right",
                  fontSize: 9,
                },
              ],
              [
                { text: "Preço c/ IPI c/ ICMS", bold: true, fontSize: 9 },
                {
                  text: UtilMoney.toR$BRL(somaValores + somaIPI),
                  alignment: "right",
                  fontSize: 9,
                },
              ],
              [
                { text: "Multas Contratuais", bold: true, fontSize: 9 },
                {
                  text: UtilMoney.toR$BRL(0),
                  alignment: "right",
                  fontSize: 9,
                },
              ],
              [
                {
                  text: "Valor Líquido",
                 bold: true,
                  fontSize: 10,
                  fillColor: "#f0f0f0",
                },
                {
                  text: UtilMoney.toR$BRL(valorLiquidoCalculado),
                  alignment: "right",
                  fontSize: 10,
                  bold: true,
                  fillColor: "#f0f0f0",
                },
              ],
            ],
          },
          layout: {
            hLineWidth: (i, node) => {
              if (i === 0 || i === node.table.body.length) return 1;
              if (i === node.table.body.length - 1) return 1.5;
              return 0.5;
            },
            vLineWidth: () => 0,
            hLineColor: () => "#cccccc",
          },
          margin: [0, 0, 0, 15],
        },

        // DESCRIÇÃO
        {
          text: [
            { text: "Descrição.......: ", bold: true, fontSize: 9 },
            { text: dado?.descricao || "", fontSize: 9 },
          ],
          margin: [0, 0, 0, 15],
        },

        // OBSERVAÇÕES
        {
          text: [
            { text: "Observações....: ", bold: true, fontSize: 9 },
            { text: dado?.observacao || "", fontSize: 9 },
          ],
          margin: [0, 0, 0, 15],
        },

        // CONDIÇÕES DE PAGAMENTO
        {
          text: [
            { text: "Cond.Pagto.....: ", bold: true, fontSize: 9 },
            { text: condicaoPagamento, fontSize: 9 },
          ],
          margin: [0, 0, 0, 15],
        },

        // EQUIPAMENTO E CONDIÇÕES
        {
          table: {
            widths: ["25%", "25%", "25%", "25%"],
            body: [
              [
                {
                  text: [
                    { text: "Equipamento..: ", bold: true, fontSize: 8 },
                    { text: tipoEquipamento, fontSize: 8 },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {
                  colSpan: 2,
                  text: [
                    {
                      text: "NÃO HÁ RESTRIÇÃO SOBRE EMISSÃO DE BOLETO.",
                      bold: true,
                      fontSize: 8,
                    },
                  ],
                  margin: [3, 3, 3, 3],
                },
                {},
              ],
            ],
          },
          layout: "noBorders",
          margin: [0, 0, 0, 10],
        },

        // LINHA SEPARADORA
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 535,
              y2: 0,
              lineWidth: 1,
              lineColor: "#000000",
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // TABELA DE ITENS
        {
          table: {
            headerRows: 1,
            widths: ["4%", "32%", "8%", "10%", "6%", "6%", "6%", "10%", "9%", "9%"],
            body: [
              [
                {
                  text: "It",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
                {
                  text: "Descrição do Item",
                  bold: true,
                  fontSize: 8,
                  alignment: "left",
                },
                {
                  text: "Quant.",
                  bold: true,
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text: "Valor Total",
                  bold: true,
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text: "IPI",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
                {
                  text: "ISS",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
                {
                  text: "ICMS",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
                {
                  text: "Base ICMS/ISS",
                  bold: true,
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text: "Prazo Entrega",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
                {
                  text: "Class. Fiscal",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
              ],
              ...this.criarLinhasItens(dado?.itens || [], tipoEquipamento),
            ],
          },
          layout: {
            hLineWidth: (i, node) => {
              if (i === 0 || i === 1 || i === node.table.body.length) return 1;
              return 0.5;
            },
            vLineWidth: () => 0.5,
            hLineColor: "#000000",
            vLineColor: "#cccccc",
          },
          margin: [0, 0, 0, 15],
        },

        {
          text: `Total: ${UtilMoney.toR$BRL(somaValores)}`,
          fontSize: 9,
          alignment: "right",
          margin: [0, -10, 0, 10],
        },

        // LINHA SEPARADORA
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 535,
              y2: 0,
              lineWidth: 1,
              lineColor: "#000000",
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // TABELA DE PRAZOS
        {
          table: {
            headerRows: 1,
            widths: ["16%", "26%", "16%", "12%", "12%", "10%", "8%"],
            body: [
              [
                {
                  text: "Vencimento",
                  bold: true,
                  fontSize: 8,
                },
                {
                  text: "Descrição",
                  bold: true,
                  fontSize: 8,
                },
                {
                  text: "Valor Parcela",
                  bold: true,
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text: "Liquidação",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
                {
                  text: "Valor Pago",
                  bold: true,
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text: "Ult.Alteração",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
                {
                  text: "Stat",
                  bold: true,
                  fontSize: 8,
                  alignment: "center",
                },
              ],
              ...this.criarLinhasPrazos(dado?.lancamentos || []),
            ],
          },
          layout: {
            hLineWidth: (i, node) => {
              if (i === 0 || i === 1 || i === node.table.body.length) return 1;
              return 0.5;
            },
            vLineWidth: () => 0.5,
            hLineColor: "#000000",
            vLineColor: "#cccccc",
          },
          margin: [0, 0, 0, 15],
        },

        {
          text: `Total: ${UtilMoney.toR$BRL(somaValores)}  |  Acréscimos: ${UtilMoney.toR$BRL(valorAcrescimos)}  |  Descontos: ${UtilMoney.toR$BRL(valorDescontos)}`,
          fontSize: 8,
          alignment: "right",
          margin: [0, -10, 0, 10],
        },

        // LINHA SEPARADORA
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 535,
              y2: 0,
              lineWidth: 1,
              lineColor: "#000000",
            },
          ],
          margin: [0, 10, 0, 15],
        },

        // DATAS DO JOB
        {
          text: "DATAS DO JOB",
          bold: true,
          fontSize: 10,
          margin: [0, 0, 0, 10],
        },

        {
          table: {
            widths: ["33%", "33%", "34%"],
            body: [
              // Envio para Aprovação
              [
                {
                  stack: [
                    {
                      text: "Envio para Aprovação",
                      bold: true,
                      fontSize: 8,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: [
                        { text: "Contratual: ", bold: true, fontSize: 7 },
                        {
                          text: dataEnvioAprovacaoContratualFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 3],
                    },
                    {
                      text: [
                        { text: "Efetiva: ", bold: true, fontSize: 7 },
                        {
                          text: dataEnvioAprovacaoEfetivaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [1, 1, 1, 1],
                  borderColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
                // Aprovação
                {
                  stack: [
                    {
                      text: "Aprovação",
                      bold: true,
                      fontSize: 8,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: [
                        { text: "Prevista: ", bold: true, fontSize: 7 },
                        {
                          text: dataAprovacaoPrevistaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 3],
                    },
                    {
                      text: [
                        { text: "Efetiva: ", bold: true, fontSize: 7 },
                        {
                          text: dataAprovacaoEfetivaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [1, 1, 1, 1],
                  borderColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
                // Inspeção
                {
                  stack: [
                    {
                      text: "Inspeção",
                      bold: true,
                      fontSize: 8,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: [
                        { text: "Prevista: ", bold: true, fontSize: 7 },
                        {
                          text: dataInspecaoPrevistaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 3],
                    },
                    {
                      text: [
                        { text: "Efetiva: ", bold: true, fontSize: 7 },
                        {
                          text: dataInspecaoEfetivaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [1, 1, 1, 1],
                  borderColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
              ],
              // Entrega Fiscal
              [
                {
                  stack: [
                    {
                      text: "Entrega Fiscal",
                      bold: true,
                      fontSize: 8,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: [
                        { text: "Prevista: ", bold: true, fontSize: 7 },
                        {
                          text: dataEntregaFiscalPrevistaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 3],
                    },
                    {
                      text: [
                        { text: "Efetiva: ", bold: true, fontSize: 7 },
                        {
                          text: dataEntregaFiscalEfetivaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [1, 1, 1, 1],
                  borderColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
                // Montagem
                {
                  stack: [
                    {
                      text: "Montagem",
                      bold: true,
                      fontSize: 8,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: [
                        { text: "Contratual: ", bold: true, fontSize: 7 },
                        {
                          text: dataMontagemContratualFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 3],
                    },
                    {
                      text: [
                        { text: "Efetiva: ", bold: true, fontSize: 7 },
                        {
                          text: dataMontagemEfetivaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [1, 1, 1, 1],
                  borderColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
                // Start-UP
                {
                  stack: [
                    {
                      text: "Start-UP",
                      bold: true,
                      fontSize: 8,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: [
                        { text: "Prevista: ", bold: true, fontSize: 7 },
                        {
                          text: dataStartupPrevistaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 3],
                    },
                    {
                      text: [
                        { text: "Efetiva: ", bold: true, fontSize: 7 },
                        {
                          text: dataStartupEfetivaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [1, 1, 1, 1],
                  borderColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
              ],
              // Entrega Final Contratual
              [
                {
                  stack: [
                    {
                      text: "Entrega Final Contratual",
                      bold: true,
                      fontSize: 8,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: [
                        { text: "Contratual: ", bold: true, fontSize: 7 },
                        {
                          text: dataFinalContratualFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 3],
                    },
                    {
                      text: [
                        { text: "Efetiva: ", bold: true, fontSize: 7 },
                        {
                          text: dataFinalEfetivaFormatada,
                          fontSize: 7,
                        },
                      ],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [1, 1, 1, 1],
                  borderColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
                { text: "", border: [0, 0, 0, 0] },
                { text: "", border: [0, 0, 0, 0] },
              ],
            ],
          },
          layout: "noBorders",
          margin: [0, 0, 0, 15],
        },

        // RODAPÉ COM INFORMAÇÕES
        {
          table: {
            widths: ["25%", "25%", "25%", "25%"],
            body: [
              [
                {
                  text: [
                    { text: "Transporte: ", bold: true, fontSize: 8 },
                    { text: transporteDescricao, fontSize: 8 },
                  ],
                },
                {
                  text: [
                    {
                      text: "Carta Fiança / Nota Promissória: ",
                      bold: true,
                      fontSize: 8,
                    },
                    { text: cartaFiancaNotaPromissoria, fontSize: 8 },
                  ],
                },
                {
                  text: [
                    { text: "Reajuste: ", bold: true, fontSize: 8 },
                    { text: reajusteDescricao, fontSize: 8 },
                  ],
                },
                {
                  text: [
                    { text: "Inspeção: ", bold: true, fontSize: 8 },
                    { text: inspecaoDescricao, fontSize: 8 },
                  ],
                },
              ],
              [
                {
                  text: [
                    { text: "Multa: ", bold: true, fontSize: 8 },
                    { text: multaDescricao || "-", fontSize: 8 },
                  ],
                },
                { text: "", fontSize: 8 },
                { text: "", fontSize: 8 },
                { text: "", fontSize: 8 },
              ],
            ],
          },
          layout: "noBorders",
          margin: [0, 0, 0, 10],
        },

        // LINHA FINAL
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 535,
              y2: 0,
              lineWidth: 0.5,
              lineColor: "#000000",
            },
          ],
          margin: [0, 0, 0, 5],
        },

        // DATA E PÁGINA
        {
          text: `Pág.: 1 - Emissão: ${dataEmissao}`,
          fontSize: 8,
          alignment: "right",
        },
      ],
    };
    
    console.log("docDef.images.logoImage:", docDef.images.logoImage ? docDef.images.logoImage.substring(0, 100) + "..." : "NULL");
    return docDef;
  }

  static criarLinhasItens(itens, tipoEquipamento) {
    const formatPercentValue = (value) => {
      if (value === null || value === undefined || value === "") return "";
      return value.toString();
    };

    const linhas = [];

    itens.forEach((item, index) => {
      // Linha principal do item
      linhas.push([
        { text: index + 1, fontSize: 7, alignment: "center" },
        {
          text: `${item.descricao || ""}\nCOD. ${item.codigo || ""}${item.tipoDeEquipamentoDescricao ? `\n[${item.tipoDeEquipamentoDescricao}]` : ""}`,
          fontSize: 7,
        },
        {
          text: item.quantidade || "0",
          fontSize: 7,
          alignment: "right",
        },
        {
          text: UtilMoney.toR$BRL(item.precoTotal || 0),
          fontSize: 7,
          alignment: "right",
        },
        {
          text: formatPercentValue(item.porcentagemIPI ?? item.IPI ?? item.valorIPI ?? ""),
          fontSize: 7,
          alignment: "center",
        },
        {
          text: formatPercentValue(item.porcentagemISS ?? item.ISS ?? item.valorISS ?? ""),
          fontSize: 7,
          alignment: "center",
        },
        {
          text: formatPercentValue(item.porcentagemICMS ?? item.ICMS ?? item.valorICMS ?? ""),
          fontSize: 7,
          alignment: "center",
        },
        {
          text: UtilMoney.toR$BRL(
            item.valorBaseICMS_ISS ??
              item.baseICMSISS ??
              item.baseICMS ??
              item.baseISS ??
              item.precoVenda_sIPI_sICMS ??
              0
          ),
          fontSize: 7,
          alignment: "right",
        },
        {
          text: item.dataPrazoEntregaFormatada || "",
          fontSize: 7,
          alignment: "center",
        },
        {
          text:
            item.classificacaoFiscalNCM ||
            item.classificacaoFiscal ||
            item.ncmCodigo ||
            item.ncm?.codigo ||
            "",
          fontSize: 7,
          alignment: "center",
        },
      ]);

      // Linhas dos subitens
      if (item.itens && Array.isArray(item.itens) && item.itens.length > 0) {
        item.itens.forEach((subitem) => {
          linhas.push([
            { text: `• ${subitem.sequencia || ""}`, fontSize: 6, alignment: "center" },
            {
              text: `${subitem.descricao || ""}\n`,
              fontSize: 6,
              margin: [10, 0, 0, 0],
            },
            {
              text: subitem.quantidade || "0",
              fontSize: 6,
              alignment: "right",
            },
            {
              text: UtilMoney.toR$BRL(subitem.valorTotal || 0),
              fontSize: 6,
              alignment: "right",
            },
            { text: "", fontSize: 6 },
            { text: "", fontSize: 6 },
            { text: "", fontSize: 6 },
            {
              text: UtilMoney.toR$BRL(subitem.valorTotal || 0),
              fontSize: 6,
              alignment: "right",
            },
            { text: "", fontSize: 6 },
            { text: "", fontSize: 6 },
          ]);
        });
      }
    });

    return linhas;
  }

  static criarLinhasPrazos(lancamentos) {
    return lancamentos.map((lancamento) => [
      { text: lancamento.dataVencimentoFormatada || "", fontSize: 8 },
      { text: lancamento.descricao || "", fontSize: 8 },
      {
        text: UtilMoney.toR$BRL(lancamento.valor || 0),
        fontSize: 8,
        alignment: "right",
      },
      { text: lancamento.dataLiquidacaoFormatada || "", fontSize: 8, alignment: "center" },
      {
        text: UtilMoney.toR$BRL(lancamento.valorPago || 0),
        fontSize: 8,
        alignment: "right",
      },
      {
        text:
          lancamento.dataUltimaAlteracaoFormatada ||
          lancamento.dataAlteracaoFormatada ||
          lancamento.dataUltAlteracaoFormatada ||
          "",
        fontSize: 8,
        alignment: "center",
      },
      {
        text: lancamento.status || lancamento.stat || "",
        fontSize: 8,
        alignment: "center",
      },
    ]);
  }
}

module.exports = UtilCapaJobPDF;
